import { useSelector } from "react-redux"
import { selectAuthInitialized, selectCredentials, selectJustLoggedOut, selectLoginCredential, selectPendingEmail } from "../../features/auth/auth-slice"
import { useCurrentUserDepartmentCode } from "../proposal/use-state-checker-proposal";
import { DEPARTMENT_CODES } from "../../constant/department-code-constant";

export const useAuthDataState = () => {

    const pendingEmail = useSelector(selectPendingEmail);
    const justLoggedOut = useSelector(selectJustLoggedOut);
    const loginCredentials = useSelector(selectLoginCredential);
    const loginEmail = loginCredentials.email
    const loginPassword = loginCredentials.password
    const isInitialized = useSelector(selectAuthInitialized);

    const credentials = useSelector(selectCredentials);
    const accessToken = credentials?.accessToken
    const refreshToken = credentials?.refreshToken
    const status = credentials?.status
    const userCredentials = credentials?.user
    const userId = userCredentials?.user_id;
    const userFirstName = userCredentials?.firstname;
    const userMiddleName = userCredentials?.middlename;
    const userLastName = userCredentials?.lastname;
    const userSuffix = userCredentials?.suffix;
    const userEmail = userCredentials?.email;
    const userAgentCode = userCredentials?.agent_code;
    const userPhoneNumber = userCredentials?.phoneNumber;
    const userIsActive = userCredentials?.is_active;
    const userIsMustChangePassword = userCredentials?.mustChangePassword;
    const userRoleId = userCredentials?.role_id;
    const userRoleName = userCredentials?.roleName;
    const userRoleCode = userCredentials?.roleCode;
    const userLocationId = userCredentials?.location_id;
    const userLocationName = userCredentials?.locationName;
    const userDepartmentId = userCredentials?.department_id;
    const userDepartmentName = userCredentials?.departmentName;
    const userDepartmentCode = userCredentials?.departmentCode;

    const isUserEBAMDepartment = useCurrentUserDepartmentCode(DEPARTMENT_CODES.EBAM);
    const isUserActuarialDepartment = useCurrentUserDepartmentCode(DEPARTMENT_CODES.ACTUARIAL);
    const isUserITDepartment = useCurrentUserDepartmentCode(DEPARTMENT_CODES.IT);
    const isUserMKT_GMSDepartment = useCurrentUserDepartmentCode(DEPARTMENT_CODES.MKT_GMS);
    const isUserSALES_AND_MKTDepartment = useCurrentUserDepartmentCode(DEPARTMENT_CODES.SALES_AND_MKT);
    const isUserMKT_ASSTDepartment = useCurrentUserDepartmentCode(DEPARTMENT_CODES.MKT_ASST);
    const isUserMonitoringGMSDepartment = useCurrentUserDepartmentCode(DEPARTMENT_CODES.MONITORING_DEPT_GMS);
    const isUserMonitoringActuarialDepartment = useCurrentUserDepartmentCode(DEPARTMENT_CODES.MONITORING_DEPT_ACTUARIAL);
    const isUserMonitoring = isUserMonitoringGMSDepartment || isUserMonitoringActuarialDepartment
    // const { isUserMonitoring } = useAuthDataState();
    // if(isUserMonitoring) return;
    return {
        pendingEmail,
        justLoggedOut,
        loginCredentials,
        loginEmail,
        loginPassword,
        isInitialized,

        credentials,
        accessToken,
        refreshToken,
        status,
        userId,
        userFirstName,
        userMiddleName,
        userLastName,
        userSuffix,
        userEmail,
        userAgentCode,
        userPhoneNumber,
        userIsActive,
        userIsMustChangePassword,
        userRoleId,
        userRoleName,
        userRoleCode,
        userLocationId,
        userLocationName,
        userDepartmentId,
        userDepartmentName,
        userDepartmentCode,

        isUserEBAMDepartment,
        isUserActuarialDepartment,
        isUserITDepartment,
        isUserMKT_GMSDepartment,
        isUserSALES_AND_MKTDepartment,
        isUserMKT_ASSTDepartment,
        isUserMonitoringGMSDepartment,
        isUserMonitoringActuarialDepartment,
        isUserMonitoring,
    }
}